import { useState, useEffect } from "react";

const IMG = (id) => `https://images.unsplash.com/photo-${id}?crop=entropy&cs=srgb&fm=jpg&q=80&w=1100`;

const IDS = [
  "1667323169496-c6a34dd8e293", // wild elephant
  "1710995164293-da854801abb5", // leopard
  "1533484482814-3fe2d922be89", // elephant herd
  "1518399681705-1c1a55e5e883", // whales
  "1456926631375-92c8ce872def", // sri lankan leopard
  "1577971132997-c10be9372519", // safari
  "1566766189074-b6300cccf96b", // macaque
];

export const WildlifeBackdrop = () => {
  const [idx, setIdx] = useState(0);
  useEffect(() => {
    const t = setInterval(() => setIdx((i) => (i + 1) % IDS.length), 3800);
    return () => clearInterval(t);
  }, []);

  return (
    <div className="absolute inset-0" data-testid="wildlife-backdrop">
      {IDS.map((id, i) => (
        <img
          key={id}
          src={IMG(id)}
          alt=""
          aria-hidden="true"
          onError={(e) => { e.currentTarget.style.display = "none"; }}
          className="absolute inset-0 w-full h-full object-cover transition-opacity duration-[1500ms] ease-in-out"
          style={{ opacity: i === idx ? 1 : 0, transform: i === idx ? "scale(1.06)" : "scale(1)", transitionProperty: "opacity, transform" }}
        />
      ))}
    </div>
  );
};
